import { ISettingsGroup } from "@ryde/shared";

export const filterSettingData = (
  items: ISettingsGroup[],
  searchText: string | undefined,
): ISettingsGroup[] => {
  if (!searchText?.trim()) {
    return items;
  }

  const filteredItems = items.filter(x =>
    x.groupItems.some(i => i.title.toLocaleLowerCase()?.includes(searchText)),
  );

  const recountedItems = filteredItems.map(x => ({
    ...x,
    groupItems: x.groupItems.filter(i =>
      i.title.toLocaleLowerCase()?.includes(searchText),
    ),
  }));
  return recountedItems;
};
